export const AppoDefaultRoute = '';
export const SelectAccount = 'select-account';
